import {CREATE, UPDATE, DELETE, FETCH_POST, FETCH_ALL, START_LOADING, END_LOADING, FETCH_BY_SEARCH,
     LIKE_POST, COMMENT} from "../constants/actionTypes"

import * as api from '../api';

// Action creators
export const getPost = (id) => async (dispatch) => {
    try {
        dispatch({type: START_LOADING})

        const {data} = await api.fetchPost(id);
        console.log(data)

        dispatch({type: FETCH_POST, payload: data})
        dispatch({type: END_LOADING})
        
    } catch (err) {
        console.log(err)
    }
}


 export const getPosts = (page) => async (dispatch) => {
    try {
        dispatch({type: START_LOADING})

        const {data} = await api.fetchPosts(page);
        console.log(data)

        dispatch({
            type: FETCH_ALL,
            payload: data
        })
        dispatch({type: END_LOADING})
        
    } catch (err) {
        console.log(err)
    }
}

export const getPostsBySearch = (searchQuery) => async (dispatch) =>{
    try{
        dispatch({type: START_LOADING})
         const {data: {data}} = await api.fetchPostsBySearch(searchQuery)
         
         dispatch({type: FETCH_BY_SEARCH, payload: data})

         dispatch({type: END_LOADING})
    } catch (error){
        console.log(error)

    }
}


export const createPost = (post, history) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try{
        dispatch({type: START_LOADING})
        
        const res = await api.createPost(post, config);
        console.log(res.data.data)

        history.push(`/posts/${res.data.data._id}`)
        dispatch({
            type: CREATE,
            payload: res.data.data
        })
       
    } catch(err){
        console.log(err)

    }
}

export const updatePost = (id, post) => async (dispatch) =>{
    try {
        const res = await api.updatePost(id, post);

        dispatch({
            type: UPDATE,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
        
    }
}

export const deletePost = (id) => async (dispatch) =>{
    try {
        await api.deletePost(id);

        dispatch({
            type: DELETE,
            payload: id
        })        
    } catch (error) {
        console.log(error)
    }
}

export const likePost = (id) =>async (dispatch) => {
    try {

        const res = await api.likePost(id);

        dispatch({
            type: LIKE_POST,
            payload: res.data
        })
        
    } catch (error) {
        console.log(error)
        
    }
}

export const commentPost = (value, id) => async(dispatch) =>{
    try{
      const {data} =  await api.comment(value, id)
    //   console.log(data)
    dispatch({type:COMMENT, payload: data})
    return data.comments;
    }catch(error) {
        console.log(error)

    }
}